import * as React from "react"
import PropTypes from "prop-types"
import "./layout.scss"
import Header from "../components/header/header"
import Footer from "../components/footer"
import "normalize.css"

const Layout = ({ children }) => {
  return (
    <div>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
